<template>

  <div>

    <center>
      <h4 v-if="landowner && landowner.name">Landowner: <span class="text-primary">{{landowner.name}}</span>&nbsp;</h4><br />
      <h5 v-if="siteData && siteData.siteName"><i><span class="text-warning">{{siteData.siteName}}</span>&nbsp;({{siteData.siteId}})&nbsp;<b>Handover: {{formatDate(siteData.handover)}}</b></i></h5>
    </center>
    <br />


    <el-form ref="tenancyFrom" v-model="tenancy" :model="tenancy" :rules="rules" inline label-position="left" label-width="110px">

      <el-tabs v-model="agMenu">

        <el-tab-pane label="Details" name="ag_details">
          <el-row v-if="!landowner.id || !landedit" :gutter="6">
            <el-col :md="24" :lg="8">
              <select-landlord label="Landlord" placeholder="Select Existing Landlord" v-model="landowner" full-object @change="updated" :disabled="landowner.id > 0" />
              <br />
            </el-col>

            <el-col v-if="landowner.id" :md="24" :lg="16">

              <div v-if="!addContact">
                <el-col :span="18">
                  <select-contact ref="contactSel" v-if="landowner.contactsCount > 0" v-model="tenancy.contact_id" placeholder="Select Owner's Rep." :org-id="landowner.id" @change="contactChange" />
                </el-col>
              </div>
              <div v-else :gutter="6">
                <el-col :span="8">
                  <text-input label="Site Rep."v-model="contact.name" prop="name" placeholder="Full name" is-prefix-icon prefix="fa fa-user" @change="contactChanged = true" />
                </el-col>

                <el-col :span="8">
                  <text-input label="Phone" type="phone" prop="phone" placeholder="Mobile phone" is-prefix-icon prefix="fa fa-mobile-alt" v-model="contact.phone"  @change="contactChanged = true" />
                </el-col>

                <el-col :span="8">
                  <text-input label="e-Mail" type="email" prop="email" placeholder="e-Mail" is-prefix-icon prefix="fa fa-envelope" v-model="contact.email" @change="contactChanged = true" />
                </el-col>
              </div>

              <el-col v-if="landowner.id" :span="addContact ? 2 : 6">
                <el-form-item :label="!addContact ? '.' : ''">
                  <span v-if="!addContact && landowner.contactsCount > 0" class="text-muted">&nbsp;- or -&nbsp;</span>
                  <el-button :type="!addContact ? 'primary' : 'success'" size="mini" @click="addContact = !addContact">
                    {{!addContact ? 'Add Contact' : 'Save'}}
                  </el-button>
                  <el-button v-if="addContact" type="info" size="mini" @click="addContact = false">
                    Cancel
                  </el-button>
                </el-form-item>
              </el-col>

            </el-col>

          </el-row>

            <el-row :gutter="6">

              <el-col :span="24">
                <el-card shadow="hover">
                  <template #header><div class="clearfix">
                    <span>Tenancy Details:</span>
                  </div></template>

                  <text-input label="Land Title Ref:" prop="landTitleRef" v-model="tenancy.landTitleRef" :disabled="disabled" />
                  <select-land-status v-model="tenancy.landStatus" prop="landStatus" :disabled="disabled" @change="check" />
                  <select-land-type placeholder="Land Type" prop="landType" v-model="tenancy.landType" :disabled="disabled" @change="check" />
                  <select-classification-type v-model="tenancy.classificationType" :disabled="disabled" @change="check"  />

                </el-card>
                <br />
              </el-col>



              <el-col v-if="!isPurchase(tenancy)" :lg="adding ? 12 : 24" :md="24">
                <el-card shadow="hover">
                  <template #header><div class="clearfix">
                    <span>Deposit:</span>
                  </div></template>

                  <currency-input label="Deposit" v-model="tenancy.deposit" :disabled="disabled" @change="check" />
                  <date-input label="Date" v-model="tenancy.depositDate" :disabled="disabled" @change="check" />
                  <integer-input v-if="!isPurchase(tenancy)" label="Deposit for" v-model="tenancy.depositMonths" suffix="months" :disabled="disabled" @change="check" />

                  <div v-if="adding && isDesktop">
                    <br />
                    <br />
                    <br />
                  </div>
                </el-card>
                <br />
              </el-col>


              <el-col v-if="((adding || !tenancy.started) || tenancy.count == 0) && !isPurchase(tenancy)" :lg="12" :md="24">
                <el-card shadow="hover">
                  <template #header><div class="clearfix">
                    <span>Tenancy Start &amp; End:</span>
                  </div></template>

                  <date-input label="Start" v-model="renewal.started"  @change="renewalCheck" :disabled="disabled" />

                  <el-row>
                    <el-col :span="16">
                      <number-input v-model="renewal.months" label="Tenor (mths)" :min="6" :max="240" :step="6" @change="check" :disabled="!adding && disabled" />
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="">
                        <i>{{years}} {{plural('yr', years)}}.</i>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-form-item label="Expiry">
                    <center><b>{{formatDate(expiryDate)}}</b></center>
                  </el-form-item>
                </el-card>
                <br />
              </el-col>



              <el-col :span="24">
                <el-card shadow="hover">
                  <template #header><div class="clearfix">
                    <span>Financials:</span>
                  </div></template>

                  <currency-input :label="'Land ' + tenancy.landType" v-model="tenancy.landValue" :disabled="disabled" @change="check" />
                  <select-frequency v-if="!isPurchase(tenancy)" v-model="tenancy.frequency" :disabled="disabled" @change="check" />
                  <switch-input v-model="tenancy.taxable" label="Taxable" @change="renewalCheck" />
                  <currency-input v-if="renewal.taxable" label="Tax" v-model="renewal.tax" :disabled="disabled" />

                  <el-row v-if="!isPurchase(tenancy)" class="clearfix">
<!--
                  <el-col :span="6">
                    <integer-input v-if="adding" label="Renewal Mths." v-model="tenancy.months" suffix="months" :disabled="disabled" @change="renewalCheck" />
                  </el-col>
-->
                  <el-col :span="6">
                    <integer-input label="Renewal Incr." v-model="tenancy.increment" suffix="%" :min="0" :max="100" :disabled="disabled" @change="renewalCheck" />
                  </el-col>

                  <el-col :span="6">
                    <currency-input label="Renewal" v-model="renewal.amount" :disabled="disabled" />
                  </el-col>

                  <el-col :span="6">
                    <currency-input label="Renewal Total" v-model="renewal.total" :disabled="disabled" />
                  </el-col>

                  </el-row>

                </el-card>
                <br />

              </el-col>

            </el-row>

          </el-tab-pane>



          <el-tab-pane :label="(adding ? 'Add ' : 'Update ') + 'Landowner'" name="tenancy_owner">
              <edit-pane
                ref="landowner"
                title="Landonwer"
                :is-edit="landedit"
                @save="onSaveLandowner"
                @cancel="landedit = false"
                @edit="landedit = true">

              <br />

              <el-alert v-if="landedit" type="info" show-icon title="Changes here affect all sites with the same landlord." :closable="false" />

              <el-form ref="landownerForm" :model="landowner" label-position="top" inline v-model="landowner">
                <text-input label="Landowner Name" prop="name" is-prefix-icon prefix="fa fa-user" v-model="landowner.name" placeholder="Name" @change="landownerChanged = true" :disabled="!landedit" />
                <text-input label="Address" prop="address" type="textarea" is-prefix-icon prefix="fa fa-home" v-model="landowner.address" placeholder="Address"  @change="landownerChanged = true" :rows="4" :disabled="!landedit" />

                <el-row :gutter="16">
                  <el-col v-if="landowner.postCode || landedit" :span="8">
                    <text-input label="Post Code" prop="postCode" is-prefix-icon prefix="fa fa-barcode" v-model="landowner.postCode" placeholder="Post Code"  @change="landownerChanged = true" :disabled="!landedit" />
                  </el-col>

                  <el-col v-if="landowner.phone || landedit" :span="8">
                    <text-input label="Phone" prop="phone" is-prefix-icon prefix="fa fa-phone" v-model="landowner.phone" placeholder="Phone" @change="landownerChanged = true" :disabled="!landedit" />
                  </el-col>

                  <el-col v-if="landowner.email || landedit" :span="8">
                    <text-input label="e-Mail" prop="email" is-prefix-icon prefix="fa fa-envelope" v-model="landowner.email" placeholder="e-mail"  @change="landownerChanged = true" :disabled="!landedit" />
                  </el-col>
                </el-row>

                <br />
                <h4 v-if="landedit">Owner's Site Representative</h4>

                <el-form ref="contactForm" :model="contact" label-position="top" inline v-model="contact">
                    <el-row>
                      <el-col v-if="landowner.contactsCount > 0" :span="8">
                        <select-contact ref="contactSel" prop="contact_id" v-model="tenancy.contact_id" label="" :org-id="landowner.id" :disabled="!landedit || addContact" @change="contactChange" />
                      </el-col>

                      <el-col v-if="landowner.id" :span="16">
                        <span v-if="landowner.contactsCount > 0" class="text-muted">&nbsp;- or -&nbsp;</span>
                        <el-button :type="!addContact ? 'primary' : 'info'" size="mini" @click="addContact = !addContact" :disabled="!landedit">
                          {{!addContact ? 'Add' : 'Close'}}
                        </el-button>
                      </el-col>
                    </el-row>

                    <el-row v-if="addContact" :gutter="12">
                      <el-col v-if="contact.name || landedit" :span="8">
                        <text-input label="Site Rep." is-prefix-icon prefix="fa fa-user" v-model="contact.name" @change="contactChanged = true" :disabled="!landedit" />
                      </el-col>

                      <el-col v-if="contact.phone || landedit" :span="8">
                        <text-input label="Phone" type="phone" prop="phone" is-prefix-icon prefix="fa fa-mobile-alt" v-model="contact.phone"  @change="contactChanged = true" :disabled="!landedit" />
                      </el-col>

                      <el-col v-if="contact.email || landedit" :span="8">
                        <text-input label="e-Mail" type="email" prop="email" is-prefix-icon prefix="fa fa-envelope" v-model="contact.email" @change="contactChanged = true" :disabled="!landedit" />
                      </el-col>
                    </el-row>
                </el-form>

                <el-row>
                  <el-col :span="24">

                    <h4 v-if="isManager('finance')">Bank Details</h4>

                    <el-collapse v-if="isManager('finance')" v-model="bene" accordion>
                      <el-collapse-item v-for="n in beneList" :name="'beneficiary' + n" :title="'Beneficiary ' + n" :key="n">
                        <el-row :gutter="16">
                          <el-col :span="12">
                            <text-input label="Beneficiary Name" v-model="landowner['beneficiaryName' + n]"  @change="landownerChanged = true" :disabled="!landedit && !disabled" />
                          </el-col>

                          <el-col :span="12">
                            <text-input label="Registration No." v-model="landowner['registrationNo' + n]"  @change="landownerChanged = true" :disabled="!landedit && !disabled" />
                          </el-col>

                          <el-col :span="12">
                            <text-input label="Bank Name" v-model="landowner['bankName' + n]"  @change="landownerChanged = true" :disabled="!landedit && !disabled" />
                          </el-col>

                          <el-col :span="12">
                            <text-input label="Bank Account" v-model="landowner['bankAccount' + n]"  @change="landownerChanged = true" :disabled="!landedit && !disabled" />
                          </el-col>
                        </el-row>

                      </el-collapse-item>
                    </el-collapse>
                  </el-col>
                </el-row>

              </el-form>
            </edit-pane>
          </el-tab-pane>




          <el-tab-pane
            v-if="canAccess('property|finance|admin')"
            label="Utility Details"
            name="utility_details">

            <el-row :gutter="12">
              <el-col :span="24">
                  <select-utility label="Provider" v-model="tenancy.util_id" />
              </el-col>

              <el-col :span="8">
                  <integer-input label="Acc. #" v-model="tenancy.utilAccount" />
              </el-col>

              <el-col :span="8">
                <currency-input label="Deposit" v-model="tenancy.utilDeposit"/>
              </el-col>

              <el-col :span="8">
                <date-input label="Deposit Date" v-model="tenancy.utilDepositDate"  @change="updated" />
              </el-col>

              <el-col :span="24">
                  <text-input label="Utility Address" type="textarea" :rows="3" v-model="tenancy.utilAddress" />
              </el-col>

            </el-row>

          </el-tab-pane>



          <el-tab-pane
            v-if="canAccess('property|project|maintenance|admin')"
            label="Site Details"
            name="site_details">

            <el-row :gutter="12">
              <el-col :span="8">
                  <integer-input label="Plot Width" v-model="tenancy.width" suffix="m." />
              </el-col>

              <el-col :span="8" :offset="1">
                <integer-input label="Plot Depth" v-model="tenancy.depth" suffix="m." />
              </el-col>
            </el-row>

          </el-tab-pane>



          <el-tab-pane label="Remarks" name="ag_remarks">
            <html-input v-model="tenancy.remarks" />
          </el-tab-pane>


        </el-tabs>

    </el-form>

  </div>

</template>


<script>


import ArrayMixins from '@/mixins/ArrayMixins'
import SiteMixins from '@/mixins/SiteMixins'
import TenancyMixins from '@/mixins/TenancyMixins'

import SelectContact from '@/components/atoms/selects/SelectContact'
import SelectLandlord from '@/components/atoms/selects/SelectLandlord'

import SelectLandStatus from '@/components/atoms/selects/SelectLandStatus'
import SelectLandType from '@/components/atoms/selects/SelectLandType'
import SelectClassificationType from '@/components/atoms/selects/SelectClassificationType'

import SelectUtility from '@/components/atoms/selects/SelectUtility'

import {ENABLE_SAVE_EVENT, DISABLE_SAVE_EVENT} from '@/components/Data'


export default {
  mixins: [ArrayMixins, SiteMixins, TenancyMixins],

  components: {
    SelectContact,
    SelectLandlord,
    SelectClassificationType,
    SelectLandStatus,
    SelectLandType,
    SelectUtility
  },

  props: {

    siteData: {
      type: Object,
      required: true
    },

    tenancyData: {
      type: Object,
      default: null
    },

    adding: {
      type: Boolean,
      default: false
    },

    editable: {
      type: Boolean,
      default: false
    },

    noDisable: {
      type: Boolean,
      default: false
    }

  },



  methods: {

    contactChange (value) {
//      this.contact = value
      this.tenancy.contact_id = value.id
      this.tenancy.contact = value
    },


    check () {

      if (this.tenancy.owner_id && this.tenancy.site_id) {

        if (this.isPurchase(this.tenancy) && this.tenancy.landValue) {
          this.tenancy.depositMonths = null
          this.$events.emit(ENABLE_SAVE_EVENT)
          return
        }

        if (this.adding) {

          if (!this.isPurchase(this.tenancy) && this.tenancy.landValue && this.renewal.started && this.renewal.expiry) {
            this.$events.emit(ENABLE_SAVE_EVENT)
            return
          }

        } else {

          if (!this.isPurchase(this.tenancy) && this.tenancy.landValue) {
            this.$events.emit(ENABLE_SAVE_EVENT)
            return
          }

        }

      }

      // Renewal creation...
      if (this.adding || this.renewalChanged) {
        this.renewalChanged = false
        this.renewal = this.renewalCalc(this.renewal, this.tenancy.landValue, this.tenancy.increment, this.tenancy.taxable)
        this.tenancy.renewal = this.renewal

        if (!this.tenancy.started && this.renewal.started) {
          this.tenancy.started = this.formatDateSql(this.renewal.started)
//          this.saveForm(this, '/tenancy', this.tenancy.id, this.tenancy, 'Tenancy', this.successTenancy, null, false)
        }
      }

      this.tenancy.utilDepositDate = this.formatDateSql(this.tenancy.utilDepositDate)

      this.$emit('update', this.tenancy, this.adding)

      if (!this.noDisable) {
        this.$events.emit(DISABLE_SAVE_EVENT)
      }
    },


    renewalCheck () {
      this.renewalChanged = true
      this.check()
    },


    updated (data) {
      this.landowner = data
      this.tenancy.owner_id = this.landowner.id
      this.tenancy.utilDepositDate = this.formatDateSql(this.tenancy.utilDepositDate)
      this.check()
    },


    successContact (data) {

      if (this.addContact) {
        this.$refs.contactSel.refresh()
      }

      this.addContact = false
      this.landowner.contactsCount++
      this.tenancy.contact_id = data.id
      this.tenancy.contact = data
    },



    successTenancy (data) {

      this.tenancy = data

      if (!this.tenancy.owner) {
        this.tenancy.owner = this.landowner
      }

      this.tenancy.utilDepositDate = this.formatDateSql(this.tenancy.utilDepositDate)

      this.$emit('update', this.tenancy, this.adding)
    },


    successLandowner (data) {
      // Saving contact info...
      this.landowner = data
      this.tenancy.owner = data

      this.landownerChanged = false
      this.landedit = false

      if (this.contactChanged && (this.contact.id || this.adding)) {
        this.contactChanged = false

        if (!this.contact.organisation_id) {
          this.contact.organisation_id = data.id
        }

        this.saveForm(this, '/contacts', this.contact.id, this.contact, 'Site Contact', this.successContact)
      }

      if (this.adding && !this.tenancy.owner_id) {

        if (!this.tenancy.owner_id) {
          this.tenancy.owner_id = this.landowner.id
          this.owner = this.landowner
        }

        this.tenancy.utilDepositDate = this.formatDateSql(this.tenancy.utilDepositDate)

        this.$emit('update', this.tenancy, this.adding)
//        this.saveForm(this, '/tenancy', this.tenancy.id, this.tenancy, 'Landowner Agreement', this.successTenancy)
      }

    },


    onSaveLandowner () {

      this.landedit = false

      if (this.landowner.id && this.contactChanged) {
        this.contactChanged = false

        if (!this.contact.organisation_id) {
          this.contact.organisation_id = this.landowner.id
        }

        this.saveForm(this, '/contacts', this.contact.id, this.contact, 'Site Contact', this.successContact)
      }

      if (this.landownerChanged) {
        this.landowner.category = 'Landlord'
        this.saveForm(this, '/org', this.landowner.id, this.landowner, 'Landowner', this.successLandowner)
      }

    },


    onSaveDialog () {

      if (!this.tenancy.owner_id && this.landowner.id) {
        this.tenancy.owner_id = this.landowner.id
      }

      if (!this.tenancy.site_id && this.siteData.id) {
        this.tenancy.site_id = this.siteData.id
      }

      if (!this.tenancy.started && this.renewal.started) {
        this.tenancy.started = this.formatDateSql(this.renewal.started)
      }

      if (!this.tenancy.expiry && this.renewal.expiry) {
        this.tenancy.expiry = this.formatDateSql(this.renewal.expiry)
      }

      this.tenancy.depositDate = this.formatDateSql(this.tenancy.depositDate)

      if (this.tenancy.utilDepositDate) {
        this.tenancy.utilDepositDate = this.formatDateSql(this.tenancy.utilDepositDate)
      }

// @TODO check whether all OK on update and add tenancy.

      // Renewal creation...
      if (this.adding || this.renewalChanged) {
        this.renewalChanged = false
        this.renewal = this.renewalCalc(this.renewal, this.tenancy.landValue, this.tenancy.increment, this.tenancy.taxable)
        this.tenancy.renewal = this.renewal
      }

      this.saveForm(this, '/tenancy', this.tenancy.id, this.tenancy, 'Tenancy', this.successTenancy)
    },



    onCloseDialog () {
      this.editing = this.adding ? true : false

      if (this.adding) {
        this.resetData()
      }

    },


    resetData () {

      if (this.adding) {
        this.landowner = this.getTableStruct('organisation')
        this.landowner.category = 'Landlord'
      }

      this.tenancy = this.originalTenancy
    }

  },



  computed: {

    expiryDate: function () {
      this.renewal.expiry = this.contractExpiryDate(this.renewal.started, this.renewal.months, 'months', 'YYYY-MM-DD')
      this.renewalChanged = true
      return this.renewal.expiry
    },

    years: function () {
      return this.renewal.months / 12
    }

  },



  data () {

    return {
      agMenu: 'ag_details',
      beneList: [1, 2, 3],
      bene: 'beneficiary1',
      disabled: !this.isManager('property|finance') || this.isViewOnly(),
      loading: false,
      editing: this.editable,
      landedit: false,
      addContact: false,
      landownerChanged: false,
      contactChanged: false,
      renewalChanged: false,
      tenancy: (this.tenancyData
        ? this.clone(this.tenancyData)
        : this.getTableStruct('tenancy')),
      renewal: (this.tenancyData && this.tenancyData.renewal
        ? this.clone(this.tenancyData.renewal)
        : this.getTableStruct('tenancy_renewals')),
      landowner: (this.tenancyData && this.tenancyData.owner
        ? this.clone(this.tenancyData.owner)
        : this.getTableStruct('organisation')),
      contact: (this.tenancyData && this.tenancyData.contact
        ? this.clone(this.tenancyData.contact)
        : this.getTableStruct('contacts')),
      originalTenancy: (this.tenancyData
        ? this.clone(this.tenancyData)
        : this.getTableStruct('tenancy')),
      site: this.siteData,
      rules: {
        started: [
          { required: true, message: 'Please enter started date', trigger: 'blur' }
        ],
        landStatus: [
          { required: true, message: 'Please enter tenancy status', trigger: 'blur' }
        ],
        landType: [
          { required: true, message: 'Please enter land type', trigger: 'blur' }
        ]
      }
    }

  }, // data



  created () {

    if (this.adding && !this.noDisable) {
//      this.$events.emit(DISABLE_SAVE_EVENT)
    }

    // NOTE: Not sure why this is necessary, but...
    if (!this.tenancy.owner_id && this.tenancy.owner) {
      this.tenancy.owner_id = this.tenancy.owner.id
    }

    if (this.tenancy.owner_id && !this.tenancy.owner) {
      this.tenancy.owner_id = null
    }


    if (!this.tenancy.site_id && this.siteData) {
      this.tenancy.site_id = this.siteData.id
      this.renewal.site_id = this.siteData.id
    }

  }

}
</script>



<style>
.el-select {
  display: inline-block;
}
</style>
